// These are the rules by which the form input fields will be checked against.

import { formHasErrors, formHasValue, setFormValues } from "./objectValidation";

/**
 * Criteria:
 * 1) Required
 */
const usernameValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "username", true, "Required");
    }

    return setFormValues(row, "username", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Must be a valid email
 */
const emailValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "email", true, "Required");
    }

    // 2)
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return setFormValues(row, "email", true, "Invalid email");
    }

    return setFormValues(row, "email", false, "");
};

// The main constant, directing to the specific validation function.
export const USER_VALIDATION = {
    username: {
        check: usernameValidation
    },
    email: {
        check: emailValidation
    }
};

export const IS_USER_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "email");
};
